import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {TypeaheadWindowComponent} from "./typeahead/typeahead-window.component";
import {PopoverComponent} from "./popover/popover.component";
import {TooltipComponent} from "./tooltip/tooltip.component";
import {PopoverDirective} from "./popover/popover.directive";
import {DateRangeComponent} from "./date/date-range/date-range.component";
import {DateFieldComponent} from "./date/date-field/date-field.component";
import {DatePickerComponent} from "./date/date-picker/date-picker.component";
import {SelectComponent} from "./select/select.component";
import {TimestampPipe} from "./date/timestamp.pipe";
import {LocalFilterComponent} from "./search/local-filter/local-filter.component";
import {TagsComponent} from "./tags/tags.component";
import {ConfirmationToggleComponent} from "./confirmation-toggle/confirmation-toggle.component";
import {FormFieldComponent} from "./form-field/form-field.component";
import {TabPanelComponent} from "./tab-panel/tab-panel.component";
import {TabItemComponent} from "./tab-panel/tab-item/tab-item.component";
import {TypeaheadDirective} from "./typeahead/typeahead.directive";
import {TimePickerComponent} from "./date/time-picker/time-picker.component";
import {AutoFocusDirective} from "./auto-focus.directive";
import {SearchComponent} from "./search/search/search.component";
import {FormComponent} from "./form/form.component";
import {PaginationComponent} from "./pagination/pagination.component";
import {SentenceCasePipe} from "./sentence-case.pipe";
import {ScrollerComponent} from "./scroller/scroller.component";
import {MultiInputComponent} from "./multi-input/multi-input.component";
import {ModalConfirmAutofocus} from "./modal-confirm/modal-confirm.component";
import {FacetDateRangeComponent} from "./facets/facet-date-range/facet-date-range.component";
import {FacetFilterComponent} from "./facets/facet-filter/facet-filter.component";
import {FacetFilterValueComponent} from "./facets/facet-filter/facet-filter-value/facet-filter-value.component";
import {
    FacetFilterBooleanValueComponent
} from "./facets/facet-filter/facet-filter-boolean-value/facet-filter-boolean-value.component";
import {RouteReuseStrategy} from "@angular/router";
import {RouteStrategyService} from "./utils/route-strategy.service";
import {ModalComponent} from "./modal/modal.component";
import {
    DefaultConfirmationDialogComponent
} from "./confirmation-modal/default-confirmation-dialog/default-confirmation-dialog.component";
import {ConfirmationModalComponent} from "./confirmation-modal/confirmation-modal.component";
import {TranslateDirective} from "./utils/translate.directive";
import {HighlightComponent} from "./typeahead/highlight/highlight.component";
import {AlertingComponent} from "./alerting/alerting.component";
import {LanguageSelectorComponent} from "./language-selector/language-selector.component";
import {StatusAlertComponent} from "./alerting/status-alert/status-alert.component";
import {BootstrapTooltipDirective} from "./bootstrap-tooltip.directive";
import {ActiveWhenUrlMatchesDirective} from "./active-when-url-matches.directive";
import {FilterComponent} from "./search/filter/filter.component";
import {OverviewComponent} from "./overview/overview.component";
import {WebsocketService} from './websocket.service';
import {FacetsOverviewComponent} from "./facets/facets-overview/facets-overview.component";
import {DatePeriodRangeComponent} from './date/date-period-range/date-period-range.component';
import {DefaultValueDirective} from './default-value.directive';
import {CountrySelectComponent} from "./country-select/country-select.component";
import {TagLabelsComponent} from "./labels/tag-labels.component";
import {MiddleEllipsisPipe} from "./middle-ellipsis.pipe";
import {SimpleMultiSelectComponent} from './simple-multi-select/simple-multi-select.component';

export const commonDeclarations = [
  // Pipes
  TimestampPipe,
  SentenceCasePipe,
  MiddleEllipsisPipe,

  // Directives
  PopoverDirective,
  AutoFocusDirective,
  TypeaheadDirective,

  // Components
  TooltipComponent,
  DateFieldComponent,
  DateRangeComponent,
  DatePickerComponent,
  DatePeriodRangeComponent,
  SelectComponent,
  SimpleMultiSelectComponent,
  FilterComponent,
  SearchComponent,
  LocalFilterComponent,
  MultiInputComponent,
  TagsComponent,
  ConfirmationToggleComponent,
  ScrollerComponent,
  FormFieldComponent,
  TabPanelComponent,
  TabItemComponent,
  TimePickerComponent,
  FormComponent,
  FacetDateRangeComponent,
  FacetFilterComponent,
  FacetFilterValueComponent,
  FacetFilterBooleanValueComponent,
  CountrySelectComponent,
  TagLabelsComponent,

  BootstrapTooltipDirective,
  ActiveWhenUrlMatchesDirective,

  // Alerting
  AlertingComponent,
  StatusAlertComponent,

  // Translations
  TranslateDirective,
  LanguageSelectorComponent,

  // Modal
  ConfirmationModalComponent,
  DefaultConfirmationDialogComponent,
  ModalComponent,
  PaginationComponent,
  ModalConfirmAutofocus,

  // Overview
  OverviewComponent,
  FacetsOverviewComponent,
]

@NgModule({ declarations: [
        commonDeclarations,
        DefaultValueDirective
    ],
    exports: [
        commonDeclarations,
        PaginationComponent,
        DefaultValueDirective,
    ], imports: [BrowserModule,
        CommonModule,
        FormsModule,
        TypeaheadWindowComponent,
        PopoverComponent,
        HighlightComponent], providers: [
        SentenceCasePipe,
        { provide: RouteReuseStrategy, useClass: RouteStrategyService },
        WebsocketService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CommonsModule {

}
